import { z } from "zod";


export const registrationSchema = z.object({
	resident_number: z.string({ error: "Resident number is required" }).min(3, "ID Number must be at least 3 characters"),
	first_name: z.string({ error: "First name is required" }).min(2, "First name is required"),
	middle_name: z.string().optional(),
	surname: z.string({ error: "Surname is required" }).min(2, "Surname is required"),
	gender: z.enum(["Male", "Female"], "Gender is required"),
	email: z.email("Invalid email address"),
	college_email: z.email("Invalid college email address"),


	resident_status: z.string({ error: "Resident status is required" }).min(1, "Resident status is required"),
	faculty: z.string({ error: "Faculty is required" }).min(1, "Faculty is required"),
	// subspecialty: z.string({ error: "Subspecialty is required" }).min(1, "Subspecialty is required"),
	subspecialty: z.string().optional(),
	training_center: z.string({ error: "Training center is required" }).min(1, "Training center is required"),
	// department: z.string({ error: "Department is required" }).min(1, "Department is required"),
	department: z.string().optional(),
	department_other: z.string().optional(),


	academic_year: z.string({ error: "Academic year is required" }).min(1, "Academic year is required"),
	current_year: z.enum(["1", "2", "3", "4", "5", "6"], "Current year is required"),


	extension_requested: z.enum(["1", "0"], "Select if you requested extension or not"),
	extension_start_date: z.string().optional(),
	extension_end_date: z.string().optional(),
	deferment_requested: z.enum(["1", "0"], "Select if you requested deferment or not"),
	deferment_start_date: z.string().optional(),
	deferment_end_date: z.string().optional(),
	external_rotation: z.enum(["1", "0"], "External rotation field is required"),
	external_start_date: z.string().optional(),
	external_end_date: z.string().optional(),
	exam_resit: z.enum(["1", "0"], "Select if you are resitting exams or not"),
	sponsoring_facility: z.string({ error: "Sponsoring facility is required" }).min(1, "Sponsoring facility is required"),

	tuition_receipt: z.any().optional(),
	training_challenges: z.string().optional(),
}).refine(
	(data) => {
		if (["4", "11"].includes(data.sponsoring_facility)) {
			return !!data.tuition_receipt;
		}
		return true;
	},
	{
		message: "Tuition receipt is required for private facility or self-sponsored residents",
		path: ["tuition_receipt"],
	}
)
	.refine(
		(data) => {
			if (data.department === "1") {
				return data.department_other && data.department_other.trim().length > 0;
			}
			return true;
		},
		{
			message: "Please specify your department",
			path: ["department_other"],
		}
	);


// export const registrationSchema = z.object({
// faculty: z.string(),
// subspecialty: z.string(),
// academicYear: z.string(),
// });